export default (paymentLinksResponseMap => paymentLinksResponseMap ? paymentLinksResponseMap.results.map(paymentLink => Object.assign({
  value: paymentLink.id
}, paymentLink)) : []);